/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Collection from 'fierry/data/collection';

import Influence from 'solis/data/board/influence';


export default class Zone extends Entity
{
  static children = [ 'influences' ];


  loadInfluence (cass)
  {
    return this.getInfluences().load(cass.sourceColony, cass);
  }


  unloadInfluence (cass)
  {
    this.getInfluences().unload(cass.sourceColony);
  }


  createInfluence (sourceColony)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.board = this.cass.board;

    cass.sourceColony = sourceColony;

    cass.targetZone = this.getAbsoluteHex();

    cass.value = 0;
    cass.established = false;

    cass.createDate = null;
    cass.destroyDate = null;

    return this.parent.loadInfluence(cass);
  }


  getInfluence (sourceColonyID)
  {
    return this.getInfluences().at(sourceColonyID);
  }


  getInfluences ()
  {
    return new Collection(Influence, this.cursor.child('influences'), this.parent);
  }


  getInfluencesForUser (userID)
  {
    return this.getInfluences().values().filter(influence => influence.getSourceUserID() === userID);
  }


  getSector ()
  {
    return this.getColony().getSector(this.cass.sector);
  }


  getColony ()
  {
    return this.parent.getColony(this.cass.colony);
  }


  getBoard ()
  {
    return this.parent;
  }


  getRelativeHex ()
  {
    return this.cass.id;
  }


  getAbsoluteHex ()
  {
    const sectorTransform = this.getSector().cass.transform;
    const colonyTransform = this.getColony().cass.transform;

    return this.getRelativeHex().transformWithObject(sectorTransform).transformWithObject(colonyTransform);
  }


};
